export const getCartItems = async () => {
	try{
		const response = await fetch('/cart.js', {
			method: 'GET',
			cache: 'no-cache'
		});
		if (!response.ok) {
      console.warn(`Failed to fetch cart items: ${response.status} ${response.statusText}`);
    }
		const currentCart = await response.json();
    return currentCart || [];
	}
	catch(e){
		console.warn("Error while fetching cart items:", e);
		return [];
	}
}